<template>
  <div class="index-main">
    <haier-search></haier-search>
    <component
        :is="item.code"
        :cmsData="item.cmsData"
        v-for="item in componentList"
        :key="item.name"
    ></component>
  </div>
</template>

<script>
import { haierGetModuleCmsConf } from '@/api/api';

export default {
  name: 'index',
  data() {
    return {
      componentList: [],
      showtip: this.$store.state.showtip,
      t: 5,
      timer: null,
    };
  },
  mounted() {
    this.getCmsData();
  },
  methods: {
    //获取cmd模板数据，遍历每个模板
    //componentList里的code模板要和前端组件对应
    //cmsData是模板的数据，要管理后台CMS里面配置的
    async getCmsData() {
      let params = {
        platform: 1,
      };
      const res = await haierGetModuleCmsConf(params);
      if (res.code == '0000') {
        this.componentList = JSON.parse(res.data.cmsData);
      }
    },
    djsFun() {
      this.timer = setInterval(() => {
        this.t--;
        if (this.t === 0) {
          this.$store.state.showtip = false;
          this.showtip = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome {
  position: absolute;
  z-index: 100;
  padding-top: 1rem;
  height: 100%;
  background: rgba(0, 0, 0, .3);

  img {
    width: 100%;
    animation-name: rotate;
    animation-duration: 1.5s;
    animation-delay: .1s;
  }
}

.c_wel {
  border-radius: 50%;
  position: absolute;
  top: 16%;
  right: 5%;
  width: 1rem;
  height: 1rem;
}

.index-main {
}
</style>
